
import { Vue, Component } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { getPartnerCompanyList } from '@/api/company'

@Component
export default class ShopList extends Vue {
  @Action setProviderId!: (val: string) => void
  @Getter companyId!: string
  @Getter info: any // 用户信息
  @Action setRootPath!: (val: string) => void;
  companyList = []

  created () {
    this.getPartnerCompanyList()
  }

  /**
   * 跳转到店铺首页
   * @param id 店铺id
   */
  toShopHome (obj: any) {
    if (!this.$isAction('shopHome')) {
      return false
    }
    this.setRootPath('/information?refreshToken=1')
    this.setProviderId(obj.companyId)
    this.$router.push({path: '/shopHome', query: {shopHomeTitle: obj.companyName}})
  }

  getPartnerCompanyList () {
    let params = {
      partnerCompanyId: this.info.partnerCompanyId || 'system',
      // partnerCompanyId:'62f315b5d5e8c81a7d7881e5'
    }
    getPartnerCompanyList(params).then(res => {
      this.companyList = res.data.companyList
    })
  }
}
